module.exports = __webpack_public_path__ + "img/image-our-story-academy-template.b028fba0.jpg";